import { useQuery } from '@tanstack/react-query';

import { SystemComponent } from 'src/features/systems/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/system/component/:componentId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    componentId: string;
    parkingId: string;
}
const queryFn = ({ componentId, parkingId }: DTO): Promise<SystemComponent> => {
    return axios.get(formatResourcePath(RESOURCE, { componentId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetSystemComponent, RESOURCE as SYSTEM_COMPONENT_RESOURCE };
